import React, { useState, useRef, useEffect } from 'react';
import './Header.css';

function Header({ onNavegar, paginaAtual, onLogout, usuario }) {
  const [menuAberto, setMenuAberto] = useState(false);
  const [colapsado, setColapsado] = useState(false);
  const [mobileAberto, setMobileAberto] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  const handleLogout = () => {
    setMenuAberto(false);
    onLogout();
  };

  const handleNavegar = (pagina) => {
    onNavegar(pagina);
    setMobileAberto(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuAberto(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuRef]);

  const navItems = [
    { id: 'inicio', label: 'Dashboard', icon: 'fa-solid fa-grid-2' },
    { id: 'clientes', label: 'Clientes', icon: 'fa-solid fa-users' },
    { id: 'calendario', label: 'Calendário', icon: 'fa-solid fa-calendar-days' },
    { id: 'leads', label: 'Busca de Leads', icon: 'fa-solid fa-magnifying-glass-chart' },
    { id: 'leads-historico', label: 'Histórico de Leads', icon: 'fa-solid fa-clock-rotate-left' },
    { id: 'marcas', label: 'Marcas', icon: 'fa-solid fa-trademark' },
    { id: 'marcas-monitoradas', label: 'Monitoradas', icon: 'fa-solid fa-binoculars' },
    { id: 'financeiro', label: 'Financeiro', icon: 'fa-solid fa-chart-line' },
    { id: 'revistas', label: 'Revistas', icon: 'fa-solid fa-newspaper' },
  ];

  return (
    <>
      {/* Mobile top bar */}
      <div className="mobile-topbar">
        <button className="mobile-menu-btn" onClick={() => setMobileAberto(!mobileAberto)}>
          <i className="fa-solid fa-bars"></i>
        </button>
        <img src="/logo.png" alt="Sefira" className="mobile-logo" />
        <div className="mobile-avatar" onClick={toggleMenu}>
          {usuario?.nome?.charAt(0) || 'U'}
        </div>
      </div>

      {/* Overlay para mobile */}
      {mobileAberto && (
        <div className="sidebar-overlay" onClick={() => setMobileAberto(false)} />
      )}

      <aside className={`sidebar ${colapsado ? 'sidebar-collapsed' : ''} ${mobileAberto ? 'sidebar-mobile-open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-header">
          <div className="sidebar-logo" onClick={() => handleNavegar('inicio')}>
            <img src="/logo.png" alt="Sefira" className="sidebar-logo-img" />
          </div>
          <button
            className="sidebar-collapse-btn"
            onClick={() => setColapsado(!colapsado)}
            title={colapsado ? 'Expandir menu' : 'Recolher menu'}
          >
            <i className={`fa-solid ${colapsado ? 'fa-angles-right' : 'fa-angles-left'}`}></i>
          </button>
        </div>

        {/* Navegacao principal */}
        <nav className="sidebar-nav">
          <div className="sidebar-nav-label">Menu</div>
          {navItems.map(item => (
            <button
              key={item.id}
              className={`sidebar-nav-item ${paginaAtual === item.id ? 'active' : ''}`}
              onClick={() => handleNavegar(item.id)}
              title={colapsado ? item.label : undefined}
            >
              <span className="sidebar-nav-icon">
                <i className={item.icon}></i>
              </span>
              <span className="sidebar-nav-text">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Usuario */}
        <div className="sidebar-footer" ref={menuRef}>
          <div className="sidebar-user" onClick={toggleMenu}>
            <div className="sidebar-avatar">
              {usuario?.nome?.charAt(0) || 'U'}
            </div>
            <div className="sidebar-user-info">
              <span className="sidebar-user-name">{usuario?.nome || 'Usuario'}</span>
              <span className="sidebar-user-role">{usuario?.cargo || ''}</span>
            </div>
            <i className={`fa-solid fa-chevron-up sidebar-user-chevron ${menuAberto ? 'rotated' : ''}`}></i>
          </div>

          {menuAberto && (
            <div className="sidebar-user-menu">
              <button className="sidebar-menu-item" onClick={() => { setMenuAberto(false); handleNavegar('perfil'); }}>
                <i className="fa-solid fa-user"></i>
                Meu Perfil
              </button>
              <button className="sidebar-menu-item" onClick={() => { setMenuAberto(false); handleNavegar('configuracoes'); }}>
                <i className="fa-solid fa-gear"></i>
                Configuracoes
              </button>
              <div className="sidebar-menu-divider" />
              <button className="sidebar-menu-item sidebar-menu-logout" onClick={handleLogout}>
                <i className="fa-solid fa-right-from-bracket"></i>
                Sair
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}

export default Header;
